<cdk-virtual-scroll-viewport
  collectionContainer
  #wizNavList="wizCollContainer"
  #wizCdkList
  wizDragDrop
  [wizDragEnabled]="dragEnabled"
  [wizDropEnabled]="dropEnabled"
  [wizDragMove]="dragMove"
  [wizEnableSelfReorder]="enableSelfReorder"
  [wizDropControlFunction]="dropControlFunction"
  [wizShowDropIndicator]="shopDropIndicator"
  class="wiz-cdk-virtual"
  [class.wiz-cdk-virtual-padding-bottom]="addBottomPaddingToViewport"
  [itemSize]="itemHeight"
  tabIndex="0"
  [minBufferPx]="itemHeight * 6"
  [maxBufferPx]="itemHeight * 25"
  (itemMouseDownEvent)="onInitDrag($event)"
  (keyNavigationEvent)="refreshAfterScroll($event)"
  (selected)="onRowSelected($event)"
  (doubleClicked)="onDoubleClick($event)"
>
  <div
    tabindex="-1"
    *cdkVirtualFor="let item of _data; let idx = index;"
    collectionItem
    [container]="wizNavList"
    [itemIndex]="idx"
    class="wiz-list-row"
    [ngStyle]="{'height': itemHeightStr}"
    [class.is-selected]="_isSelected(item)"
    [id]="idx"
    [item]="item"
  >
    <!-- <div>{{itIdx}}</div> -->
    <ng-container
      *ngTemplateOutlet="getTemplate(); context: { $implicit: item, index: idx, itemRenderer: wizItemRenderer }"
    >
    </ng-container>
  </div>
</cdk-virtual-scroll-viewport>

<!-- Template de base, affichage du labelField-->
<ng-template #defaultRenderer let-item let-index="index">
  <span style="padding-left: 5px">{{ getItemLabel(item) }}</span>
</ng-template>

<!-- Template utilisant un renderer custom -->
<ng-template #dynamicRenderer let-item let-index="index" let-itemrndr="itemRenderer">
  <!-- appel de la directive wizTemplateItemRenderer pour injection du renderer -->
  <div [wizTemplateItemRenderer]="itemrndr" [context]="{index: index}" [data]="item" [owner]="this"></div>
</ng-template>
